import T from '../../../../../../common/components/T';

export const gridThead = {
    data: [
        {
            type: 'login',
            name: 'user',
            title: <T textName='users-modal-grid-thead-1-v1' defaultStr='ФИО, ID' />
        },
        // {
        //     type: 'status',
        //     name: 'status',
        //     title: <T textName='users-modal-grid-thead-2' defaultStr='Статус' />
        // },
        {
            type: 'rang',
            title: <T textName='qualification' defaultStr='Квалификация' />,
            name: 'rank',
            align: 'left'
        },
        {
            type: 'contacts',
            name: 'contacts',
            title: <T textName='users-modal-grid-thead-3' defaultStr='Контакты' />
        }
    ]
};

export const transformGridData = (data) => {
    return {
        ...data,
        data: data?.data?.map((elem) => ({
            user: {
                username: elem?.username,
                full_name: elem?.full_name,
                id: elem?.id,
                image: elem?.image
            },
            rank: elem?.marketing_profile?.rank,
            contacts: elem?.contacts,
            id: elem?.id
        }))
    };
};
